<template>
    <div class="modal-content">
        <form novalidate @submit.prevent="login" id="login-modal-form">
            <ErrorMessage v-if="errorMessage" :error-message="errorMessage"></ErrorMessage>
            <div>
                    <Input
                        ref="emailInput"
                        type="email"
                        placeholder="Ваш email*"
                        v-model.trim="email"
                        :invalid="$v.email.$error"
                        @keydown.space.prevent
                    />
                <div
                        v-if="$v.email.$dirty && !$v.email.required"
                        class="invalid-feedback"
                >
                    Поле обязательно для заполнения
                </div>
                <div
                        v-else-if="$v.email.$dirty && !$v.email.email"
                        class="invalid-feedback"
                >
                    Некорректный E-mail
                </div>
            </div>
        
            <div class="form-group-password">
                <Input
                    :type="passwordFieldType"
                    placeholder="Ваш пароль*"
                    v-model.trim="password"
                    :invalid="$v.password.$error"
                    @keydown.space.prevent
                />
                <button
                        class="toggle-password-btn"
                        type="button"
                        @click="togglePasswordVisibility"
                >
                    <span v-if="passwordFieldType === 'password'" key="ico-visibility-off"><ico name="icoVisibilityOff"
                                                                                                color="#626262"></ico></span>
                    <span v-else key="ico-visibility"><ico name="icoVisibility" color="#626262"></ico></span>
                </button>
                <div
                        v-if="$v.password.$dirty && !$v.password.required"
                        class="invalid-feedback"
                >
                    Поле обязательно для заполнения
                </div>
                <div
                        v-else-if="$v.password.$dirty && !$v.password.minLength"
                        class="invalid-feedback"
                >
                    Пароль должен содержать не менее {{$v.password.$params.minLength.min}} символов
                </div>
            </div>
            <div class="enter-button-wrapper">
                <Button
                    variant="gradient"
                    type="submit"
                    :disabled="isDisabled"
                    :title="isDisabled ? 'Заполните обязательные поля' : ''"
                    class="button"
                >
                    Войти
                </Button>
                <div class="forgot-password-wrapper">
                    <button
                            class="forgot-password"
                            type="button"
                            @click="openRecoveryPasswordModal"
                    >
                        Забыли пароль?
                    </button>
                </div>
            </div>
            <Button
                variant="plain"
                type="button"
                @click="openRegistrationModal"
                class="button"
            >
                Зарегистрироваться
            </Button>
        </form>
    </div>
</template>

<script>
    import {email, minLength, required} from 'vuelidate/lib/validators'
    import RegistrationModal from '@/components/homePage/RegistrationModal'
    import {mapActions} from "vuex"
    import {purchasesPath} from "@/router/purchases"
    import {RecoveryPasswordModalProperties, RegistrationModalProperties} from '@/utils/modalsProperties'
    import ErrorMessage from '@/components/common/ErrorMessage'
    import RecoveryPasswordModal from "@/components/homePage/RecoveryPasswordModal"
    import {connectWS} from "@/websocket/client"
    import {serviceUnavailable} from "@/utils/constants/errorMessages"
    import Input from "@/components/homePage/Input";
    import Button from '@/components/homePage/Button'


    export default {
        name: "LoginModal",
        data() {
            return {
                email: '',
                password: '',
                passwordFieldType: 'password',
                errorMessage: null,
            }
        },
        components: {
            ErrorMessage,
            Input,
            Button
        },
        validations: {
            email: {required, email},
            password: {required, minLength: minLength(8)}
        },
        computed: {
            isDisabled: function () {
                return !this.email || !this.password
            },
        },
        methods: {
            ...mapActions('auth', ['loginUser']),
            togglePasswordVisibility() {
                this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password'
            },
            async login() {
                if (this.$v.$invalid) {
                    this.$v.$touch()
                    return
                }

                const credentials = {
                    email: this.email,
                    password: this.password
                }

                try {
                    await this.loginUser(credentials)
                    await this.$router.push(purchasesPath)
                    connectWS()
                    this.$modal.container.destroyModal()
                } catch (e) {
                    if (e.status) {
                        this.$toast.error(serviceUnavailable + "(2)")
                        return
                    }
                    this.errorMessage = e.message
                    if (e.cleanPassword) {
                        this.password = null
                    }
                }
            },
            openRegistrationModal() {
                this.$modal.show(
                    RegistrationModal,
                    null,
                    RegistrationModalProperties
                )
            },
            openRecoveryPasswordModal() {
                this.$modal.show(
                    RecoveryPasswordModal,
                    null,
                    RecoveryPasswordModalProperties
                )
            },
        },
        mounted() {
            this.$refs['emailInput'].focus()
        }
    }
</script>

<style lang="less" scoped>
    @import '../../assets/less/variables.less';
    .modal-content {
        form {
            display: flex;
            flex-direction: column;
            gap: 25px;
            .enter-button-wrapper {
                position: relative;
                width: 100%;
            }
            .button {
                height: 60px;
                font-family: Montserrat;
                font-weight: 600;
                font-size: 24px;
                line-height: 1;
                width: 100%;
            }
        }
    }

    .forgot-password-wrapper {
        text-align: right;
    }

    .forgot-password {
        font-family: Montserrat;
        font-weight: 500;
        font-size: 16px;
        line-height: 1;
        color: #FFFFFF;
        margin-top: 10px;
        &:hover {
            color: #A5D8FF;
        }
    }
</style>
